import React from 'react';
import { CalendarDaysIcon, HandHelpingIcon, SmartphoneIcon, NotebookPenIcon } from 'lucide-react';
import { instantAccessItems } from '../data/kit';
const icons = {
  calendar: CalendarDaysIcon,
  hands: HandHelpingIcon,
  phone: SmartphoneIcon,
  notebook: NotebookPenIcon
};
export function InstantAccessSection() {
  return <section className="py-20 px-4 bg-brand-creamAlt" data-id="element-80" data-mp="1hmiww9e8svm8">
      <div className="max-w-4xl mx-auto text-center" data-id="element-81" data-mp="1wcgrp86ogjke">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-12" data-id="element-82" data-mp="1wf301a1e733o">
          ¿Qué recibís al instante?
        </h2>

        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12" data-id="element-83" data-mp="25denx4avjmsf">
          {instantAccessItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.text} className="bg-white rounded-2xl p-5 flex items-center justify-center gap-3 shadow-sm border border-brand-creamDark/50" data-id="element-84" data-mp="20cqzmqe15k1w">
                <Icon className="w-5 h-5 text-brand-green shrink-0" aria-hidden="true" data-id="element-85" data-mp="62wzdksh8dd5" />
                <span className="font-bold text-brand-text" data-id="element-86" data-mp="2s1tatm6jrxbr">{item.text}</span>
              </li>;
        })}
        </ul>

        <p className="text-2xl font-serif italic text-brand-green font-bold" data-id="element-87" data-mp="2wyjraam9kuxp">
          Cubrís el material de todo el año
        </p>
      </div>
    </section>;
}